import Head from 'next/head';
import Link from 'next/link';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import { BreadcrumbSectionDTO } from '@lib/strapi/dtos/components/sections/breadcrumbSection.dto';

/**
 * Breadcrumb + BreadcrumbList JSON-LD (items 23/D28). With flat root URLs the
 * trail is what restores the hierarchy the path no longer shows — and Google
 * renders it in results in place of the URL.
 */
const SITE = 'https://myphysiowave.gr';

const BreadcrumbSectionImplementation = ({ section, page }: ComponentProps<BreadcrumbSectionDTO>) => {
  if (!section || section.style === 'Homepage') return null;
  const links = section.links ?? [];
  const pageEntity = (page as { entity?: { title?: string; displayName?: string } } | undefined)?.entity;
  // team members carry displayName, not title
  const current = section.currentPageTitle || pageEntity?.title || pageEntity?.displayName || '';

  return (
    <>
      <Head>
        <script type="application/ld+json"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: [
                ...links.map((l, i) => ({
                  '@type': 'ListItem', position: i + 1, name: l.title, item: `${SITE}${l.url ?? ''}`,
                })),
                { '@type': 'ListItem', position: links.length + 1, name: current },
              ],
            }),
          }}
        />
      </Head>
      <nav aria-label="breadcrumb" className="flex flex-wrap items-center gap-2 text-sm text-muted">
        {links.map((l, i) => (
          <span key={i} className="flex items-center gap-2">
            <Link href={l.url ?? '/'} className="font-bold text-violet-700 hover:underline">{l.title}</Link>
            <span aria-hidden="true" className="opacity-50">›</span>
          </span>
        ))}
        <span>{current}</span>
      </nav>
    </>
  );
};

export default BreadcrumbSectionImplementation;
